import { useContext } from 'react'
import { AlertsContext } from '../context/Alerts/AlertsContext'
import { FreshWaterContext } from '../context/FreshWater/FreshWaterContext'
import { SeaWaterContext } from '../context/SeaWater/SeaWaterContext'
import { ControlServicesContext } from '../context/SeaWater/ControlServices/ControlServicesContext'
import { AuthContext } from '../context/Auth/AuthContext'
import { NecropsyContext } from '../context/Necropsy/Provider'
import { FuelContext } from '../context/Logistics/fuel/FuelProvider'

export const useContextApp = () => {
  const authContext = useContext(AuthContext)
  const alertContext = useContext(AlertsContext)
  const freshWaterContext = useContext(FreshWaterContext)
  const seaWaterContext = useContext(SeaWaterContext)
  const controlServicesContext = useContext(ControlServicesContext)
  const necropsyContext = useContext(NecropsyContext)
  const fuelContext = useContext(FuelContext)

  return {
    ...authContext,
    ...alertContext,
    freshWaterContext,
    seaWaterContext,
    controlServicesContext,
    necropsyContext,
    fuelContext,
  }
}
